module.exports = __webpack_public_path__ + "img/4.bda9cf8a.jpg";